module.exports = __webpack_public_path__ + "static/media/EE4E56DC-D417-4D16-8E7B-F598FC816308.fd082297.jpg";